import React from "react";
import { Box, Button, Modal } from "@mui/material";
import ResidentModal from "./ResidentModal";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  maskedAccountId,
} from "../common/Utils";
import { useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import styled from "@emotion/styled";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import FormControl from "@mui/material/FormControl";
import FormControllabel from "@mui/material/FormControlLabel";
import { DatePicker } from "@mui/x-date-pickers";
import { InputAdornment, IconButton } from "@mui/material";
import dayjs from "dayjs";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { useNavigate } from "react-router-dom";
import SearchModal from "./SearchModal";
import { useSelector } from "react-redux";
import SSNTextField from "../common/SSNTextField";
import { Check } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

let k = "";
let p = "";
let r = "";
let s = "";
let y = "";
var today_date = new Date();

k = today_date.getMonth() + 1;
if (today_date.getMonth() + 1 < 10) {
  p = today_date.getMonth() + 1;
  k = "0" + p;
}
s = today_date.getDate();
if (today_date.getDate() < 10) {
  r = today_date.getDate();
  s = "0" + r;
}
y = today_date.getFullYear();
var today_date = k + "/" + s + "/" + y;

export default function Residentform() {
  const [nameRowHeight, setRowHeight] = useState("65px");
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedAccRadioValue, setAccRadioValue] = useState("");
  const [open, setOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorstatus, seterrorstatus] = React.useState(false);
  const [verifymodalopen, setverifymodalOpen] = React.useState(false);
  const [searchmodalopen, setsearchmodalOpen] = React.useState(false);
  const [name, setname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [ssn, setssn] = React.useState("");
  const [mydate, setmydate] = React.useState("");
  const [hasFocus, setFocus] = useState(false);
  const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
  useEffect(() => {
    setCareFacilityDefaultVals();
  }, [carefacilitydetails]); //it should come on every render

  const setCareFacilityDefaultVals = () => {
    setFields({
      ...enrollmentFields,
      tele_number: carefacilitydetails.phone,
      contact: carefacilitydetails.contactPerson,
      address: {
        street: carefacilitydetails.address,
        city: carefacilitydetails.city,
        state: carefacilitydetails.state,
        zip_code: carefacilitydetails.zip,
      },
      mask_accNum: maskedAccountId(carefacilitydetails.accountNumber),
      accountNum: carefacilitydetails.accountNumber,
    });
  };
  const handlesearchmodalclose = () => {
    setsearchmodalOpen(false);
  };
  const handlesearchmodalOpen = () => {
    setsearchmodalOpen(true);
  };
  const handlemodalclose = () => {
    setverifymodalOpen(false);
  };
  const [fieldErrors, setErrors] = useState({
    err_firstName: false,

    firstName_helperText: "",
    lastName_helperText: "",
    SSN_helperText: "",
    allowance_helperText: "",
  });
  const handleOpen = () => {
    var error = false;
    if (enrollmentFields.firstName === "") {
      setErrors({
        ...fieldErrors,
        err_firstName: true,
        firstName_helperText: "First Name is required",
      });
      setRowHeight("80px");
      error = true;
      return;
    }
    if (enrollmentFields.lastName === "") {
      setErrors({
        ...fieldErrors,
        err_lastName: true,
        lastName_helperText: "Last Name is required",
      });
      setRowHeight("80px");
      error = true;
      return;
    }
    if (enrollmentFields.residentStatus == null) {
      seterrorstatus(true);
      error = true;
      return;
    }

    if (!error) {
      setverifymodalOpen(true);
    }
  };

  const [snackbardata, setsnackbardata] = useState(false);
  function handlesnackbardata(data) {
    setsnackbardata(data);
  }
  const [contentsopen, setcontentsOpen] = React.useState("");
  const contentopen = () => {
    setcontentsOpen(enrollmentFields.SSN);
    setTimeout(contentclose, 1500);
  };
  const contentclose = () => {
    setcontentsOpen("*********");
  };
  const handleclose = (event) => {
    setOpen(false);
  };

  const [indicatordata, setindicatordata] = useState(false);
  function handleindicatordata(data) {
    setindicatordata(data);
  }
  const handleOnBlur = (e) => {
    if (!e.target.value.trim()) {
      setFocus(false);
    }
  };
  const handleClickShowSSN = () => {
    setShowSSN(!showSSN);
  };
  const [showSSN, setShowSSN] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setsnackbardata(false);
    }, 5000);
  }, [snackbardata]);
  const [enrollmentFields, setFields] = useState({
    firstName: "",
    lastName: "",
    SSN: "",
    accountNum: "",
    mask_accNum: "",
    address: {
      street: "",
      city: "",
      state: "",
      zip_code: "",
    },
    tele_number: "",
    contact: "",
    repre_payee: "",

    enroll_date: today_date,
    picker_date: new Date(),
    medi: "",
    residentId: 0,
    allowance: "",
    residentStatus: null,
    enrollmentId: ""
  });
  const inputHandler = (e) => {
    setFields({ ...enrollmentFields, [e.target.name]: e.target.value });
    if (e.target.name === "residentStatus") {
      setFields({ ...enrollmentFields, [e.target.name]: e.target.value });
      setAccRadioValue(e.target.value);
    }
    setcontentsOpen("*****");
  };
  const BackButton = styled(Button)({
    borderColor: "#002d82",
    border: "2px solid",
    color: "#002d82",
    borderRadius: "5px",
  });

  
  const getDefaultDate = (date) => {
    var newDate = date ? new Date(date) : new Date();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");
    const year = newDate.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  };
  //myobject
  const populateData = (rowdata) => {
    console.log(
      mydate,
      rowdata.ssn,
      rowdata.payeeLastName,
      rowdata.payeeFirstName
    );
    setname(rowdata.payeeFirstName);
    setlastname(rowdata.payeeLastName);
    setssn(rowdata.ssn);
    if (rowdata.achEDate != null) {
      setmydate(rowdata.achEDate);
    }
    if (rowdata.residentStatus === "R") {
      setAccRadioValue("Released");
    } else if (rowdata.residentStatus === "D") {
      setAccRadioValue("Deceased");
    } else {
    }

    setcontentsOpen("**********");
    setFields({
      ...enrollmentFields,
      firstName: rowdata.payeeFirstName,
      lastName: rowdata.payeeLastName,
      SSN: rowdata.ssn,
      residentId: rowdata.id,

      picker_date: rowdata.achEDate
      ? rowdata.achEDate
      : getDefaultDate(enrollmentFields.picker_date),
      enroll_date: rowdata.achEDate ? rowdata.achEDate: getDefaultDate(enrollmentFields.picker_date),

      //enroll_date: rowdata.achEDate === null ? getDefaultDate(enrollmentFields.picker_date) : rowdata.achEDate,
      residentStatus: rowdata.residentStatus,
      enrollmentId: rowdata.enrollmentId
    });
    setErrors({ ...fieldErrors, err_firstName: false });
    //setFields({...enrollmentFields, enroll_date: today_date})
  };

  let k = "";
  let p = "";
  let r = "";
  let s = "";
  let y = "";
  const dateHandler = (e) => {
    var date = new Date(e.$d);
    k = date.getMonth() + 1;
    if (date.getMonth() + 1 < 10) {
      p = date.getMonth() + 1;
      k = "0" + p;
    }
    s = date.getDate();
    if (date.getDate() < 10) {
      r = date.getDate();
      s = "0" + r;
    }
    y = date.getFullYear();
    var finalDate = k + "/" + s + "/" + y;
    setFields({
      ...enrollmentFields,
      enroll_date: finalDate,
      picker_date: finalDate,
    });
  };

  useEffect(() => {}, [mydate]);

  const handleClose = () => {
    setModalOpen(false);
    navigate("/residentListings");
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          left: "25%",
          flexDirection: "column",
          width: "50%",
          marginTop: "20px",
          marginBottom: "20px",
          alignItems: "center",
          p: "0% 2%",
          backgroundColor: "#fcfcfc",
          border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
        <h2 className="header">Resident Status Form</h2>
        <Divider
          variant="fullwidth"
          sx={{ backgroundColor: "#dfe3e8" }}
        ></Divider>
        <br></br>
        <Grid>
          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >

          {/* {<Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${nameRowHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
               <p className="input-label">
                  Care Facility <span id="note">*</span>
                </p>
                <TextField
                        select
                        id="care-facility-list"
                        label=""
                        //value={childCareFacility}
                        defaultValue="Select"
                        variant="outlined"
                        name="childCareFacility"
                                        //onChange={onChangeFacility}
                        sx={{ minWidth: "165px", width:"165px", "& .MuiSelect-select":{ padding: "8px 10px !important", minWidth:"165px", width:"165px", height:"9px !important"} }}
                        //className="facility-account"
                        SelectProps={{
                
                        MenuProps: {
                         PaperProps: {
                          style: {
                        maxHeight: 200,
                      },
                    },
                    },
                    }}
                    >
                    <MenuItem key="Child1" value="Child1">Child1</MenuItem>
                    <MenuItem key="Child2" value="Child2">Child2</MenuItem>
                    <MenuItem key="Child3" value="Child3">Child3</MenuItem>
                    <MenuItem key="Child4" value="Child4">Child4</MenuItem>
                </TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">Account No.</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="XXXXXXXX1234"
                  value={enrollmentFields.mask_accNum}
                  title={enrollmentFields.accountNum}
                  name="account no"
                  onChange={inputHandler}
                  sx={{ width: "215px", "& .MuiInputBase-root input":{height: "20px !important", padding: "10px 10px !important"}  }}
                ></TextField>
               
              </Box>
          </Stack>} 

            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>*/}

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${nameRowHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">
                  First Name<span id="note">*</span>
                </p>
                {fieldErrors.err_firstName ? (
                  <TextField
                    error
                    helperText={fieldErrors.firstName_helperText}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment id="tf">
                          <IconButton
                            id="searchicon"
                            onClick={handlesearchmodalOpen}
                            sx={{ padding: "0 !important", boxShadow: "none" }}
                          >
                            <PersonSearchIcon id="searchicon" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{
                      readOnly: true,
                      onClick: handlesearchmodalOpen,
                    }}
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="First Name"
                    value={enrollmentFields.firstName}
                    name="firstName"
                    onChange={inputHandler}
                    sx={{ width: "190px" }}
                  ></TextField>
                ) : (
                  <TextField
                  sx={{ paddingRight: "0 !important", width: "190px" }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment id="tf">
                          <IconButton
                            id="searchicon"
                            onClick={handlesearchmodalOpen}
                            sx={{ padding: "0 !important", boxShadow: "none" }}
                          >
                            <PersonSearchIcon id="searchicon" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{
                      readOnly: true,
                      onClick: handlesearchmodalOpen,
                    }}
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="First Name"
                    value={name}
                    name="firstName"
                    onChange={inputHandler}
                  ></TextField>
                )}
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">
                  Last Name<span id="note">*</span>
                </p>

                {fieldErrors.err_lastName ? (
                  <TextField
                    error
                    helperText={fieldErrors.lastName_helperText}
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Last Name"
                    value={enrollmentFields.lastName}
                    name="lastName"
                    onChange={inputHandler}
                    sx={{ width: "190px" }}
                  ></TextField>
                ) : (
                  <TextField
                    variant="outlined"
                    inputProps={{ readOnly: true, maxLength: 50 }}
                    margin="none"
                    label=""
                    placeholder="Last Name"
                    value={lastname}
                    name="lastName"
                    onChange={inputHandler}
                    sx={{
                      paddingRight: "0 !important",
                      paddingLeft: "0 !important",
                      width: "220px",
                    }}
                  ></TextField>
                )}
               
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">
                  SSN<span id="note">*</span>
                </p>
                <SSNTextField
                  name="SSN"
                  onChange={inputHandler}
                  value={enrollmentFields.SSN}
                  showSSN={showSSN}
                  setFocus={setFocus}
                  handleOnBlur={handleOnBlur}
                  handleClickShowSSN={handleClickShowSSN}
                  editable="No"
                />
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label-date">
                  Date<span id="note">*</span>
                </p>
                <DatePicker
                  sx={{ marginLeft: "50px !important" }}
                  inputFormat="MM DD YYYY"
                  onChange={dateHandler}
                  value={
                    enrollmentFields.enroll_date != ""
                      ? dayjs(enrollmentFields.enroll_date)
                      : dayjs(enrollmentFields.picker_date)
                  }
                ></DatePicker>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="input-label-status"
                  id="status"
                  sx={{ color: "black" }}
                >
                  <strong>
                    Status<span id="note">*</span>
                  </strong>
                </p>

                <FormControl>
                  <RadioGroup
                    name="radio-buttons-group"
                    sx={{ flexDirection: "row", ml: 0, marginRight: "0px" }}
                  >
                    <FormControllabel
                      sx={{
                        marginRight: "40px !important",
                        ml: "64px !important",
                      }}
                      control={<Radio />}
                      name="residentStatus"
                      checked={selectedAccRadioValue === "Released"}
                      onChange={inputHandler}
                      value="Released"
                      label="Released"
                    />
                    <FormControllabel
                      control={<Radio />}
                      name="residentStatus"
                      checked={selectedAccRadioValue === "Deceased"}
                      onChange={inputHandler}
                      value="Deceased"
                      label="Deceased"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Stack>
          </Grid>
          {errorstatus && <p id="note">Resident Status is mandatory...!</p>}
          <br></br>

          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", mb: "5px" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">Point of Contact</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  value={enrollmentFields.contact}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="Contact"
                  name="Contact"
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">Account No.</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="XXXXXXXX1234"
                  value={enrollmentFields.mask_accNum}
                  title={enrollmentFields.accountNum}
                  name="account no"
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              sx={{ width: "100%", height: "150px" }}
            >
              <p className="input-label">Address</p>
              <Box
                display="grid"
                sx={{
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gridTemplateRows: "auto",
                  gridTemplateAreas: `"street street street" "city state zip"`,
                  columnGap: 2,
                  rowGap: 1,
                  ml: "12px",
                }}
              >
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="Street"
                  value={enrollmentFields.address.street}
                  name="add_street"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "street" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="City"
                  value={enrollmentFields.address.city}
                  name="add_city"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "city" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="State"
                  value={enrollmentFields.address.state}
                  name="add_state"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "state" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="Zip Code"
                  value={enrollmentFields.address.zip_code}
                  name="add_code"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "zip" }}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">Telephone No</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  placeholder="Telephone"
                  value={enrollmentFields.tele_number}
                  name="tele_number"
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
            </Stack>
          </Grid>
          <p id="note">
            Note : Fields marked as * are mandatory to be entered...!
          </p>

          <Grid
            item
            xs={12}
            sx={{
              mt: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              sx={{ width: "350px", justifyContent: "space-between" }}
            >
               {location && location.state && location.state.routeName &&
                location.state.routeName != "" ?
                <BackButton
                variant="outlined"
                sx={{ width: "140px", height: "40px", margin: "5px" }}
                onClick={() => {
                  navigate("/residentListings");
                }}
              >
                Back
              </BackButton>
                :
              <BackButton
                variant="outlined"
                sx={{ width: "140px", height: "40px", margin: "5px" }}
                onClick={() => {
                  navigate("/home");
                }}
              >
                Back
              </BackButton>
              }
            </Box>
            <Box>
              <Button onClick={handleOpen} id="btn1" variant="contained">
                Submit
              </Button>
            </Box>
          </Grid>

          {/*below one is resident user search model */}
          {searchmodalopen && (
            <SearchModal
              ssnfunc={setcontentsOpen}
              getData={populateData}
              open={searchmodalopen}
              plzclose={handlesearchmodalclose}
            />
          )}

          {/*below one is resident verification model */}
          {verifymodalopen && (
            <ResidentModal
              enrollmentFields={enrollmentFields}
              plzopen={verifymodalopen}
              plzclose={handlemodalclose}
              requestsnackbardata={handlesnackbardata}
              requestindicatordata={handleindicatordata}
              setSuccess={setSuccess}
              setErrorMsg={setErrorMsg}
              setModalOpen={setModalOpen} 
            />
          )}
          {open && console.log("open modal")}
          {indicatordata && (
            <>
              <Backdrop
                sx={{
                  color: "white",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={true}
              >
                <CircularProgress sx={{ color: "white" }} />
                <span> &nbsp;&nbsp;&nbsp;&nbsp; Submitting... </span>
              </Backdrop>
            </>
          )}
          {/* <Fade in={snackbardata} timeout={{ enter: 100, exit: 2500 }}>
            <Snackbar
              open={true}
              onClose={handleclose}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
            >
              <Alert severity="success" sx={{ width: "100%" }}>
                Form Submitted successfully..!
              </Alert>
            </Snackbar>
          </Fade> */}
          <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <>
            {success && (
              <Box sx={style}>
                <IconButton
                  sx={{ border: "2px solid green", boxShadow: "none" }}
                >
                  <Check sx={{ color: "green" }} />
                </IconButton>
                <p>
                  Resident Status created successfully!
                </p>
                <Button
                  id="modal-close-btn"
                  variant="contained"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </Box>
            )}
          </>
        </Modal>
          <br></br>
        </Grid>
      </Box>
    </>
  );
}
